/**
 * Granel Product Page JavaScript
 * Handles product interactions and cart functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Flavor selection functionality
  const flavorOptions = document.querySelectorAll('.flavor-option');
  
  flavorOptions.forEach(option => {
    option.addEventListener('click', function() {
      // Remove selected class from all options
      flavorOptions.forEach(opt => {
        opt.classList.remove('selected');
      });

      // Add selected class to clicked option
      this.classList.add('selected');
      
      // Update variant selection if needed
      const variantId = this.dataset.variantId;
      if (variantId) {
        // Update product form or variant selection
        updateVariantSelection(variantId);
      }
    });
  });

  // FAQ functionality
  const faqQuestions = document.querySelectorAll('.faq-question');
  
  faqQuestions.forEach(question => {
    question.addEventListener('click', function() {
      const faqItem = this.parentElement;
      const isActive = faqItem.classList.contains('active');

      // Close all FAQ items
      document.querySelectorAll('.faq-item').forEach(item => {
        item.classList.remove('active');
      });

      // Open clicked item if it wasn't active
      if (!isActive) {
        faqItem.classList.add('active');
      }
    });
  });

  // Toggle details functionality
  const verMaisBtn = document.querySelector('.ver-mais-btn');
  if (verMaisBtn) {
    verMaisBtn.addEventListener('click', toggleDetails);
  }
});

// Add to cart functionality
function addToCart() {
  const selectedFlavor = document.querySelector('.flavor-option.selected');
  
  if (selectedFlavor) {
    const variantId = selectedFlavor.dataset.variantId;
    
    if (variantId) {
      // Add to cart with selected variant
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Show success message
        showCartNotification('Produto adicionado ao carrinho!');
        
        // Update cart count if element exists
        updateCartCount();
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        showCartNotification('Erro ao adicionar produto ao carrinho', 'error');
      });
    } else {
      showCartNotification('Por favor, selecione um sabor', 'warning');
    }
  } else {
    showCartNotification('Por favor, selecione um sabor', 'warning');
  }
}

// Toggle details functionality
function toggleDetails() {
  const expandedContent = document.getElementById('expandedContent');
  const verMaisBtn = document.querySelector('.ver-mais-btn');
  const verMaisText = document.querySelector('.ver-mais-text');

  if (expandedContent && verMaisBtn && verMaisText) {
    if (expandedContent.style.display === 'none') {
      expandedContent.style.display = 'block';
      verMaisBtn.classList.add('expanded');
      verMaisText.textContent = 'Ver menos';
    } else {
      expandedContent.style.display = 'none';
      verMaisBtn.classList.remove('expanded');
      verMaisText.textContent = 'Ver mais';
    }
  }
}

// Update variant selection
function updateVariantSelection(variantId) {
  // This function can be customized based on your variant selection needs
  console.log('Selected variant:', variantId);
}

// Show cart notification
function showCartNotification(message, type = 'success') {
  // Create notification element
  const notification = document.createElement('div');
  notification.className = `cart-notification ${type}`;
  notification.textContent = message;
  
  // Style the notification
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 15px 20px;
    border-radius: 8px;
    color: white;
    font-weight: 600;
    z-index: 1000;
    animation: slideIn 0.3s ease;
  `;
  
  // Set background color based on type
  switch(type) {
    case 'error':
      notification.style.backgroundColor = '#dc2626';
      break;
    case 'warning':
      notification.style.backgroundColor = '#f59e0b';
      break;
    default:
      notification.style.backgroundColor = '#10b981';
  }
  
  // Add to page
  document.body.appendChild(notification);
  
  // Remove after 3 seconds
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease';
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 300);
  }, 3000);
}

// Update cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);
